export default "__VITE_ASSET__8b846a06__"